<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <div class="d-none d-md-block">
      <div v-if="this.orders[0] != null || this.vessels[0] != null">
        <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          style="height: 100vh"
          :options="{ zoomControl: false }"
          @update:zoom="zoomUpdated"
          @update:center="centerUpdated"
          @update:bounds="boundsUpdated"
        >

          <l-control-zoom position="topleft"></l-control-zoom>

          <l-control-layers position="topleft"></l-control-layers>

          <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            layer-type="base"
          />

          <l-control position="bottomleft">
            <b-toast
              id="example-toast"
              :title="notification_title"
              static
              class="mb-3 rounded-0 min-width"
              style="min-width: 600px !important"
              variant="successs"
              dismissible
              no-auto-hide
            >
              {{ notification }}
            </b-toast>
          </l-control>

          <l-control :position="'topright'">
            <b-card
              no-body
              class="transparent sidecard"
            >
              <b-tabs card>

                <!-- Orders -->

                <b-tab
                  title="Ordrer"
                  active
                  class="height-scroll"
                >

                  <b-form-input
                    class="mb-3"
                    v-model="searchOrders"
                    placeholder="Søk ordrer.."
                  ></b-form-input>

                  <h6 v-if="this.orders[0] == null">Ingen ordrer tilgjengelig</h6>

                  <!-- <b-form-select
                    class="mb-3"
                    v-on:input="changeOrder()"
                    v-model="order"
                    :options="ordersSelect"
                  ></b-form-select> -->

                  <div
                    :v-if="orders[0] != null"
                    v-for="order in filterBy(orders, searchOrders)"
                    :key="order.id"
                  >

                    <div>

                      <b-badge class="mb-3" pill v-if="order.status == 'Bestilling'" variant="secondary">{{ order.status }} </b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'Ordre'" variant="primary">{{ order.status }}</b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'I arbeid'" variant="dark">{{ order.status }}  </b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'Arbeid avsluttet'" variant="warning">{{ order.status }}</b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'Til fakturering'" variant="info">{{ order.status }}</b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'Fakturert'" variant="success">{{ order.status }}</b-badge>
                      <b-badge class="mb-3" pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>

                      <h5>{{ order.ordernumber }} - {{ order.customer_company.name }} -
                        {{ order.site.name }}</h5>

                      Type oppdrag: {{order.type}}
                      <br>
                      Startdato: {{ $date(order.startdate).format("DD.MM.YYYY") }}
                      <br>
                      <span v-if="order.vessel != null">
                        Fartøy: {{order.vessel.name}}
                        <br>
                      </span>

                      <span v-if="order.captain != null">
                        Skipper: {{order.captain.name}}
                        <br>
                      </span>

                      <b-button
                        class="mr-1 mt-3"
                        variant="primary"
                        size="sm"
                        @click="changeOrder(order)"
                      >Vis i kart</b-button>

                      <b-button
                        class="mr-1 mt-3"
                        variant="primary"
                        size="sm"
                        @click="editOrder(order)"
                      >Rediger</b-button>

                      <hr>
                    </div>

                  </div>

                </b-tab>

                <!-- Vessels   -->

                <b-tab
                  title="Fartøy"
                  class="height-scroll"
                >

                  <b-form-input
                    class="mb-3"
                    v-model="searchVessels"
                    placeholder="Søk fartøy.."
                  ></b-form-input>

                  <div
                    :v-if="vessels[0] != null"
                    v-for="vessel in filterBy(vessels, searchVessels)"
                    :key="vessel.id"
                  >

                    <div>

                      <h5>{{ vessel.name }} </h5>

                      Destinasjon: {{vessel.destination}}
                      <br>
                      ETA: {{ $date(vessel.eta).format("DD.MM.YYYY") }}
                      <br>

                      <span>
                        Posisjon: {{vessel.lat}}, {{vessel.lng}}
                        <br>
                      </span>

                      <span>
                        Sist oppdatert: {{ $date(vessel.updatedAt).format("DD.MM.YYYY HH:mm") }}
                        <br>
                      </span>

                      <b-button
                        class="mt-3 mr-1"
                        variant="primary"
                        size="sm"
                        @click="viewVessel(vessel)"
                      >Vis i kart</b-button>

                      <hr>
                    </div>

                  </div>

                </b-tab>

                <!-- Messages   -->

                <!--            <b-tab title="Meldinger">
                  <div
                    class="messages-scroll"
                    ref="msgContainer"
                  >
                    <ul class="timeline">
                      <li
                        v-for="message in messages"
                        :key="message.id"
                      >
                        <div class="mb-1">
                          <b-card
                            class="mr-3 no-transparent"
                            no-body
                          ><span class="p-3">{{ message.text }}</span>
                          </b-card>
                          <span>
                            <small>
                              {{ message.from }} -
                              {{ message.createdAt | dayjs("from") }}</small>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <b-row class="pl-3 pr-3 pb-3">

                    <b-col md="12">
                      <b-form-textarea
                        v-on:keyup.enter="sendMessage()"
                        v-model="message"
                        placeholder="Melding"
                        rows="3"
                        max-rows="3"
                        :no-resize="true"
                      ></b-form-textarea>
                    </b-col>

                    <b-col>
                      <b-button
                        class="mr-3 mt-3"
                        @click="sendMessage()"
                        variant="primary"
                      >Send melding</b-button>
                    </b-col>
                  </b-row>
                </b-tab> -->

                <!-- <b-tab
                  title="Logg"
                  class="height-scroll"
                >
                  <div ref="logsContainer">

                    <b-form-input
                      class="mb-3"
                      v-model="searchLogs"
                      placeholder="Søk logg.."
                    ></b-form-input>

                    <ul class="timeline">
                      <li
                        v-for="log in filterBy(logs, searchLogs)"
                        :key="log.id"
                      >
                        <h5>{{ log.ordernumber }} - {{ log.customer }} -
                          {{ log.site }}</h5>
                        <div class="mb-1">
                          <div>{{ log }}
                          </div>
                          <span>
                            <small>
                              Opprettet {{ log.regtime | dayjs("from") }}</small>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>

                </b-tab> -->
              </b-tabs>

            </b-card>
          </l-control>

          <l-circle
            :v-if="orders[0] != null"
            v-for="order in orders"
            :key="order.id"
            :lat-lng="[order.site.lat, order.site.lng]"
            :color="circle.color"
            :radius="circle.radius"
          >
            <div v-if="order.site.name != null">
              <l-tooltip :options="{ permanent: true, interactive: true }">
                
              <b-badge class="mr-1" v-if="order.status == 'Bestilling'" variant="secondary">{{ order.status }} </b-badge>
              <b-badge class="mr-1" v-if="order.status == 'Ordre'" variant="primary">{{ order.status }}</b-badge>
              <b-badge class="mr-1" v-if="order.status == 'I arbeid'" variant="dark">{{ order.status }}  </b-badge>
              <b-badge class="mr-1" v-if="order.status == 'Arbeid avsluttet'" variant="warning">{{ order.status }}</b-badge>
              <b-badge class="mr-1" v-if="order.status == 'Til fakturering'" variant="info">{{ order.status }}</b-badge>
              <b-badge class="mr-1" v-if="order.status == 'Fakturert'" variant="success">{{ order.status }}</b-badge>
              <b-badge class="mr-1" v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>

                {{ order.ordernumber }} - {{ order.customer_company.name }} -
                <span>{{ order.site.name }}</span>
              </l-tooltip>
              <l-popup>

              <b-badge class="mb-3" pill v-if="order.status == 'Bestilling'" variant="secondary">{{ order.status }} </b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'Ordre'" variant="primary">{{ order.status }}</b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'I arbeid'" variant="dark">{{ order.status }}  </b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'Arbeid avsluttet'" variant="warning">{{ order.status }}</b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'Til fakturering'" variant="info">{{ order.status }}</b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'Fakturert'" variant="success">{{ order.status }}</b-badge>
              <b-badge class="mb-3" pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>

               
              <div v-if="order.customer_company.name != null">
                  <h5>
                    {{ order.ordernumber }} - {{ order.customer_company.name }} -
                    {{ order.site.name }}
                  </h5>
                  <hr>

                  Kunde:
                  <h6>
                    {{ order.customer_company.name }}
                  </h6>
                </div>

                Lokasjon:
                <h6>
                  {{ order.site.number }} -
                  {{ order.site.name }}
                </h6>

                Type:
                <h6>{{ order.type }}</h6>

                Bestilt:
                <h6>{{ $date(order.createdAt).format("DD.MM.YYYY") }}</h6>

                Startdato:
                <h6>{{ $date(order.startdate).format("DD.MM.YYYY") }}</h6>

                <div v-if="order.vessel != null">
                  Fartøy:
                  <h6>{{ order.vessel.name }}</h6>
                </div>

                Status:
                <h6>{{ order.status }}</h6>

                <b-button
                  class="mt-1 mr-1"
                  variant="primary"
                  size="sm"
                  @click="editOrder(order)"
                >Rediger</b-button>

                <br />
              </l-popup>
            </div>
          </l-circle>

          <l-circle
            :v-if="vessels[0] != null"
            v-for="vessel in vessels"
            :key="vessel.id"
            :lat-lng="[vessel.lat, vessel.lng]"
            :color="circleVessel.color"
            :radius="circleVessel.radius"
          >
            <l-popup>

              <div v-if="vessel != null">

                <h5>
                  {{ vessel.name }}
                </h5>
                <hr>

              </div>

               <b-row>
                <b-col>

                  <div v-if="vessel != null">
                    Lat:
                    <h6>
                      {{ vessel.lat }}
                    </h6>
                  </div>

                </b-col>

                <div v-if="vessel.imo != null">
                  Lng:
                  <h6>
                    {{ vessel.lng }}
                  </h6>
                </div>

                <b-col>

                </b-col>
              </b-row>

              <b-row>
                <b-col>

                  <div v-if="vessel != null">
                    MMSI:
                    <h6>
                      {{ vessel.mmsi }}
                    </h6>
                  </div>

                </b-col>

                <div v-if="vessel.imo != null">
                  IMO:
                  <h6>
                    {{ vessel.imo }}
                  </h6>
                </div>

                <b-col>

                </b-col>
              </b-row>

              <b-row>
                <b-col>

                  <div v-if="vessel.callsign != null">
                    Kallesignal:
                    <h6>
                      {{ vessel.callsign }}
                    </h6>
                  </div>

                </b-col>

                <b-col>

                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">

                  <div v-if="vessel.destination != null">
                    Destinasjon:
                    <h6>
                      {{ vessel.destination }}
                    </h6>
                  </div>

                </b-col>

                <b-col md="6">

                  <div v-if="vessel.eta != null">
                    ETA:
                    <h6>
                      {{ $date(vessel.eta).format("DD.MM.YYYY HH:mm") }}

                    </h6>
                  </div>

                </b-col>

                <b-col>

                  <div v-if="vessel.eta != null">
                    Sist oppdatert:
                    <h6>
                      {{ $date(vessel.updatedAt).format("DD.MM.YYYY HH:mm") }}

                    </h6>
                  </div>

                </b-col>

              </b-row>

              <!-- {{ vessel }} -->

            </l-popup>
            <l-tooltip :options="{ permanent: true, interactive: true }">
              <div>{{ vessel.name }}</div>
              <!-- <span>{{ vessel.lat }},{{ vessel.lng }}</span> -->
            </l-tooltip>
          </l-circle>
        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";


import io from "socket.io-client";

const socket = io("https://api.eines-as.no", {
  transports: ["websocket"],
  upgrade: false,
});


import "leaflet/dist/leaflet.css";

import { Icon } from "leaflet";
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import {
  LMap,
  LTileLayer,
  LMarker,
  LControlLayers,
  LControl,
  LPopup,
  LCircle,
  LPolyline,
  LLayerGroup,
  LTooltip,
  LControlZoom,
  LControlAttribution,
  LControlScale,
} from "vue2-leaflet";

export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LPopup,
    LCircle,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      user: {},
      company: {},
      order: {},
      orders: [],
      vessels: [],
      sites: [],
      ais: [],
      notification: null,
      notification_title: null,
      logs: [],
      log: null,
      messages: [],
      message: null,
      connected: false,
      showOrder: false,
      ordersSelect: [],
      searchOrders: "",
      searchVessels: "",
      searchLogs: "",
      zoom: 4,
      tileProviders: [
        {
          name: "Mapbox",
          visible: true,
          url:
            "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
          attribution:
            '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        },

        {
          name: "Mapbox Satelitte",
          visible: false,
          url:
            " https://api.mapbox.com/styles/v1/packtracker-com/ckn0730vs0urb17prj3ndsm1p/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
          attribution:
            '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        },
        {
          name: "Maptiler",
          visible: false,
          url: "https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=vdsxLIYHfN8c65M100ny",
          attribution:
            '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        },
        {
          name: "Maptiler (Sattelite)",
          visible: false,
          url: "https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=vdsxLIYHfN8c65M100ny",
          attribution:
            '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        }, 
        {
          name: "OpenStreetMap",
          visible: false,
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '<a href="https://www.aquaservices.no">Aquaservices</a> ',
        },
      ],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '<a href="https://www.aquaservices.no">Aquaservices</a> ',
      center: L.latLng(65.355, 14.7487),
      circle: {
        radius: 100,
        color: "#022D56",
      },

      circleVessel: {
        radius: 1,
        color: "#025D46",
      },
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filteredOrders() {
      return this.orders.filter((orders) => {
        return orders.match(this.searchOrders);
      });
    },
    filteredVessels() {
      return this.ais.filter((ais) => {
        return ais.match(this.searchVessels);
      });
    },
    filteredLogs() {
      return this.logs.filter((logs) => {
        return logs.match(this.searchLogs);
      });
    },
    sumMessagesTotal() {
      return this.messages.length;
    },
  },
  watch: {
    logs: function () {
      this.$nextTick(function () {
        var container = this.$refs.logsContainer;
        container.scrollTop = container.scrollHeight + 120;
      });
    },
    center: function () {
      this.$nextTick(function () {
        this.$forceUpdate();
      });
    },
  },
  methods: {
    getUser() {
      axios.get("https://api.eines-as.no/users/me").then((res) => {
        this.user = res.data;
        this.company = res.data.company;
      });
    },
    getOrders() {
      this.isLoading = true;

      var company = localStorage.getItem("company");

      axios
        .get(
          "https://api.eines-as.no/orders?_sort=startdate:ASC&_where[supplier_company]=" +
            company + "&status=I arbeid&status=Ordre&status=Arbeid avsluttet&_where[archived]=false"
        )
        .then((response) => {
          this.orders = response.data;

          var orderSelect = [];
          var orderDataArray = response.data;

          orderDataArray.forEach((data) => {
            var orderObject = {
              value: data,
              text:
                data.ordernumber +
                " - " +
                data.customer_company.name +
                " (" +
                data.site.name +
                ")",
            };
            orderSelect.push(orderObject);
          });

          this.ordersSelect = orderSelect;

          this.isLoading = false;
        });
    },
    getMessages() {
      var company = localStorage.getItem("company");

      axios
        .get(
          "https://api.eines-as.no/messages?_limit=100&_sort=createdAt:ASC&_where[company]=" +
            company
        )
        .then((response) => {
          this.messages = response.data;
        });
    },
    getLogs() {
      var company = localStorage.getItem("company");

      axios
        .get(
          "https://api.eines-as.no/logs?_limit=100&_sort=createdAt:ASC&_where[company]=" +
            company
        )
        .then((res) => {
          this.logs = res.data;
        });
    },
    getSites() {
      axios
        .get("https://api.eines-as.no/sites?_limit=-1")
        .then((res) => {
          this.sites = res.data;
        });
    },
    getVessels() {
      var company = localStorage.getItem("company");

      axios
        .get(`https://api.eines-as.no/vessels?_where[company]=` + company)
        .then((response) => {
          this.vessels = response.data;
          //console.log(this.vessels);
        });
    },
    updateOrder() {
      this.isLoading = true;
      axios
        .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
        .then((response) => {
          this.order = response.data;

          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    sendMessage() {
      var messageData = {
        text: this.message,
        from: this.user.username,
        company: this.company.id,
        user: this.user.id,
      };
      this.message = "";
      axios
        .post("https://api.eines-as.no/messages", messageData)
        .then((response) => {})
        .catch(function (error) {
          console.log(error);
        });
    },
    sendLogMessage() {
      this.isLoading = true;

      var logData = {
        type: "message",
        data: this.message,
        from: this.user.username,
        to: this.company.id,
        order: this.order.id,
      };

      this.message = "";

      axios
        .post("https://api.eines-as.no/logs", logData)
        .then((response) => {
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    changeOrder(order) {
      this.zoom = 10;
      this.showOrder = true;

      this.refreshMap();
      this.center = L.latLng(order.site.lat, order.site.lng);
      this.marker = L.latLng(order.site.lat, order.site.lng);
    },
    viewVessel(vessel) {
      this.zoom = 10;
      this.showVessel = true;

      this.refreshMap();
      this.center = L.latLng(vessel.lat, vessel.lng);
      this.marker = L.latLng(vessel.lat, vessel.lng);
    },
    editOrder(order) {
      this.$router.push("/dashboard/order-edit/" + order.id);
    },

    editOrderPopup(order) {
      let route = this.$router.resolve({
        path: "/dashboard/order-edit/" + order.id,
      });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, "_blank");
    },

    refreshMap() {
      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 150);
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
  },
  mounted: function () {
    socket.on("message", (data) => {
      this.messages.push(data);
    });

    socket.on("fls", (data) => {
      this.notification_title =
        moment().format("HH:mm") +
        " - FLS: " +
        data.ordernumber +
        " - " +
        data.customer +
        " - " +
        data.site;
      this.notification = data;
      this.$bvToast.show("example-toast");
      this.logs.push(data);
    });

    socket.on("logs", (data) => {
      this.logs.push(data);
      this.notification =
        moment().format("HH:mm") + " - Logg: " + JSON.stringify(data);
    });
  },
  created: function () {
    this.getUser();
    this.getOrders();

    this.getVessels();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.leaflet-container {
  font: inherit;
}

.leaflet-popup {
  min-width: 350px;
}

.sidecard {
  max-height: 96 vh;
}

.transparent {
  background-color: rgba(245, 245, 245, 0.6) !important;
}

.height-scroll {
  /* %-height of the viewport */
  max-height: 90vh;
  min-height: 90vh;
  overflow-x: hidden !important;
  max-width: 450px;
  min-width: 450px !important;
}

.min-width {
  min-width: 400px;
}

.no-transparent {
  background-color: rgba(245, 245, 245, 1) !important;
}

/* Timeline */

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #022d56;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>